var React = require('react');

function R2 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"R2"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("polygon",{"points":"7.6 19.2 49.63 84.27 0 77.84 7.6 19.2","fill":"#73c9bd","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("path",{"d":"M39,29.58A27,27,0,0,0,13.94.83h0L1.63,0,18.51,54A27,27,0,0,0,39,29.58Z","fill":"#f47643","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

R2.defaultProps = {"viewBox":"0 0 49.63 84.27"};

module.exports = R2;

R2.default = R2;
